import styled from 'styled-components'

import _Icon from '../../Icon'
import { mq, sizes } from '../../../theme'

export const Container = styled.div<{ $backgroundColor?: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme, $backgroundColor }) =>
    $backgroundColor || theme.colors.pureWhite};
  border-radius: 0.3rem;
  padding: 0.5rem 0.8rem;
  width: fit-content;
`

export const Icon = styled(_Icon)`
  width: 1.6rem;
  height: 1.6rem;
  display: flex;
  margin-right: 0.5rem;
`

export const Text = styled.div<{ $textColor?: string }>`
  text-align: center;
  ${({ theme }) => theme.textStyles.text_bold_16};
  color: ${({ theme, $textColor }) => $textColor || theme.colors.pureWhite};

  /* @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.text_medium_18};
  } */
`
